import { render, staticRenderFns } from "./SchedaValutazioneEsigenzeImmediateView.vue?vue&type=template&id=d55942a4"
import script from "./SchedaValutazioneEsigenzeImmediateView.vue?vue&type=script&lang=js"
export * from "./SchedaValutazioneEsigenzeImmediateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports